import React from 'react';
import { useRouteMatch, Switch, Route } from 'react-router-dom';
import SideBar from '../components/SideBar';
import { useMediaQuery } from 'react-responsive';
import styles from './styles.module.css';
import { financeAdminTabs } from './tabs';

import Profile from '../pages/Agency/Profile';


import RefundManagement from '../pages/RefundManagement/OrderRefunds';
import AgencyRefunds from '../pages/RefundManagement/AgencyRefunds';
import TransactionReport from '../pages/RefundManagement/TransactionsReport';

/**
 * @return {JSX.Element}
 */
function FinanceAdminRouter(props) {
    const { url } = useRouteMatch();
    console.info('url', url);
    const isMobile = useMediaQuery({ maxWidth: 767 });

    return (
        <div className={styles.container}>
            <div className={styles.body}>
                {!isMobile ? (
                    <div className={styles.sideBar}>
                        <SideBar
                            tabs={financeAdminTabs}
                            roleId={0}
                        />
                    </div>
                ) : null}
                <div className={styles.relative}>
                    <div className={styles.bodyWrapper}>
                        <Switch>
                            <Route path={`${url}/refund-management/order`}>
                                <RefundManagement />
                            </Route>
                            <Route path={`${url}/refund-management/agency`}>
                                <AgencyRefunds />
                            </Route>
                            <Route path={`${url}/transaction-report`}>
                                <TransactionReport />
                            </Route>

                            <Route path={`${url}/refund-management`}>
                                <RefundManagement />
                            </Route>
                            <Route path={`${url}/profile`}>
                                <Profile />
                            </Route>
                        </Switch>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FinanceAdminRouter;
